/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsiUserDto } from '../../models/asi-user-dto';

export interface GetUserInfo$Params {
}

export function getUserInfo(http: HttpClient, rootUrl: string, params?: GetUserInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<AsiUserDto>> {
  const rb = new RequestBuilder(rootUrl, getUserInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsiUserDto>;
    })
  );
}

getUserInfo.PATH = '/auth/userInfo';
